"use client";

import {NeoLabel, PlusIcon} from "@/components/shared";
import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import toast from "react-hot-toast";

export const VehicleFileUpload = forwardRef(function VehicleFileUpload(
  {
    type,
    onChange,
    className = ""
  }: {
    type: number;
    onChange: (type: number, file: File | null) => void;
    className?: string;
  },
  ref
) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const ALLOWED_TYPES = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/pdf"
  ];

  useImperativeHandle(ref, () => ({
    trigger: () => {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
        fileInputRef.current.click();
      }
    }
  }));

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;

    if (file && ALLOWED_TYPES.includes(file.type)) {
      setSelectedFile(file);
      onChange(type, file);
    } else {
      toast.error("Only image and PDF files are allowed");
    }

    e.target.value = "";
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files?.[0] || null;

    if (file && ALLOWED_TYPES.includes(file.type)) {
      setSelectedFile(file);
      onChange(type, file);
    } else {
      toast.error("Only image and PDF files are allowed");
    }
  };

  return (
    <div className={`mb-5 w-1/2 ${className}`}>
      <div className="-mt-2">
        <NeoLabel label="Attachment" value="" />
      </div>
      <div
        className="flex cursor-pointer items-center justify-between rounded-md border border-dashed border-[#A8A8A8] p-1 text-white"
        onClick={handleUploadClick}
        onDrop={handleDrop}
        onDragOver={e => e.preventDefault()}
      >
        <span className="flex items-center space-x-2 text-black">
          <span className="text-md font-normal text-[#07A537]">
            <PlusIcon />
          </span>
          <span className="text-md font-normal text-[#07A537]">
            Add Attachment
          </span>
        </span>

        <button
          className="rounded-md bg-[#07A537] px-2 py-1 font-normal text-white"
          onClick={e => {
            e.stopPropagation();
            handleUploadClick();
          }}
        >
          Upload
        </button>

        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{display: "none"}}
        />
      </div>
      <p className="text-sm text-blue-700">Maximum 3 files can be uploaded.</p>
    </div>
  );
});
